import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";

import { FuseSharedModule } from "@fuse/shared.module";

import { ScheduleComponent } from "./schedule.component";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatOptionModule } from "@angular/material/core";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatButtonModule } from "@angular/material/button";
import { MatDatepicker, MatDatepickerModule } from "@angular/material/datepicker";
import { MatIconModule } from "@angular/material/icon";
import { MatTableModule } from "@angular/material/table";
import { ScheduleService } from "./schedule.service";
import { SnackBarService } from "app/services/snackbar.service";
import { FuseConfirmDialogComponent } from "@fuse/components/confirm-dialog/confirm-dialog.component";
import {MatCardModule} from '@angular/material/card';
import {MatBadgeModule} from '@angular/material/badge';
import {MatDialogModule} from '@angular/material/dialog';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner'; 

import {WaitingListComponent} from './components/waiting-list/waiting-list.component'
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatTabsModule } from "@angular/material/tabs";
import { MatProgressBar, MatProgressBarModule } from "@angular/material/progress-bar";
import { MatTooltipModule } from "@angular/material/tooltip";

const routes = [
    {
        path: "agenda",
        component: ScheduleComponent,
    },
];

@NgModule({
    declarations: [ScheduleComponent, WaitingListComponent],    
    imports: [
        RouterModule.forChild(routes),

        TranslateModule,

        FuseSharedModule,
        MatFormFieldModule,
        MatInputModule,
        MatOptionModule,
        MatSelectModule,
        MatTableModule,
        MatButtonModule,
        MatIconModule,
        MatDatepickerModule,
        MatAutocompleteModule,
        MatCardModule,
        MatBadgeModule,
        MatDialogModule,
        MatTabsModule,
        MatProgressSpinnerModule,
        MatTooltipModule,
        MatPaginatorModule
    ],
    providers: [ScheduleService, SnackBarService],
    exports: [ScheduleComponent],
    entryComponents: [FuseConfirmDialogComponent]
})
export class ScheduleModule {}
